import React from 'react';
import './_minibasket.scss';
import BasketIcon from '@/assets/logos/basket.svg';
import { addKr } from '@/utils/helper';
import { IBasket } from '@/types/simo/basket';

interface IProps {
  basket?: IBasket;
  goToBasket: () => void;
}

const MiniBasket = (props: IProps) => {
  const { basket, goToBasket } = props;
  return (
    <>
      <section className="mini-basket ys-card ys-card--medium-corners mb-3">
        <div className="mini-basket__content ys-row">
          <div className="ys-col-lg-2 ys-col-3 mt-1" onClick={() => goToBasket()}>
            <BasketIcon className="mini-basket__content__icon" />
            <div className="mini-basket__content__icon__text">Se Kurv</div>
          </div>
          <div className="ys-col-lg-8 ys-col-6">
            <h2 className="mini-basket__content__headline">Betal pr. måned </h2>
            <h2 className="mini-basket__content__headline">Engangsbetaling</h2>
          </div>
          <div className="ys-col-3 ys-col-lg-2">
            <h2 className="mini-basket__content__headline mini-basket__content__headline--right-align">
              {basket?.priceSummaries[0].recurringTotal.listPrice && (
                <span className="mini-basket__content__headline--strikethrough">
                  {addKr(basket?.priceSummaries[0].recurringTotal.listPrice)}
                </span>
              )}
              {addKr(basket?.priceSummaries[0].recurringTotal.price)}
            </h2>
            <h2 className="mini-basket__content__headline mini-basket__content__headline--right-align">
              {basket?.priceSummaries[0].feesTotal.listPrice && (
                <span className="mini-basket__content__headline--strikethrough">
                  {addKr(basket?.priceSummaries[0].feesTotal.listPrice)}
                </span>
              )}
              {addKr(basket?.priceSummaries[0].feesTotal.price)}
            </h2>
          </div>
        </div>
      </section>
    </>
  );
};

export default MiniBasket;
